import { Page } from 'components/Shared/Page'
import { PatronTool } from './PatronTool'
import { RewardsProgramTool } from './RewardsProgramTool'
import { Tab, Tabs, Typography } from '@mui/material'
import { useState } from 'react'
import { DeleteB2cAccount } from './DeleteB2cAccount'
import { PatronAppCurrentVersion } from './PatronAppCurrentVersion'
import { Utilities } from './Utilities'
import { FlaggedPhoneNumbers } from './FlaggedPhoneNumbers'

type TabType =
  | 'patron tools'
  | 'rewards program tools'
  | 'delete b2c account'
  | 'patron app current version'
  | 'utilities'
  | 'flagged phone numbers'

export const SupportTools = () => {
  const [activeTab, setActiveTab] = useState<TabType>('patron tools')

  return (
    <Page>
      <Typography variant="h1">Support Tools</Typography>
      <Tabs
        value={activeTab}
        onChange={(_event, newValue: TabType) => setActiveTab(newValue)}
        className="mb-4"
      >
        <Tab label="Patron Tools" value="patron tools" />
        <Tab label="Rewards Program Tools" value="rewards program tools" />
        <Tab label="Delete Patron + B2C Account" value="delete b2c account" />
        <Tab
          label="Patron App Current Version"
          value="patron app current version"
        />
        <Tab label="Utilities" value="utilities" />
        <Tab label="Flagged Phone Numbers" value="flagged phone numbers" />
      </Tabs>

      {activeTab === 'patron tools' && <PatronTool />}
      {activeTab === 'rewards program tools' && <RewardsProgramTool />}
      {activeTab === 'delete b2c account' && <DeleteB2cAccount />}
      {activeTab === 'patron app current version' && (
        <PatronAppCurrentVersion />
      )}
      {activeTab === 'utilities' && <Utilities />}
      {activeTab === 'flagged phone numbers' && <FlaggedPhoneNumbers />}
    </Page>
  )
}
